var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 29,
    viewBox: "0 0 347 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 28.7138C3.66667 19.2138 15.8 0.81378 59 3.21378C113 6.21378 168.5 33.2138 206 18.2138C243.5 3.21378 290 3.21378 347 3.21378",
    stroke: "#391A60",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanVector);
export default __webpack_public_path__ + "static/media/loanVector.8ffd330ed0bab2bb64c6ec1e1192514f.svg";
export { ForwardRef as ReactComponent };